import React from 'react';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import _ from 'lodash';
import {Theme} from '@material-ui/core'
import {ButtonProps} from '@material-ui/core/Button/Button'
import {TopNavBarButton} from 'module/TopNavBar/type/TopNavBarButton'

export const useStyles = makeStyles<Theme, { btnDef?: TopNavBarButton }>(theme => ({
	root: {
		backgroundColor: ({btnDef}) => btnDef?.backgroundColor && _.get(theme.palette, btnDef.backgroundColor)?.main || theme.palette.primary.main,
		color: ({btnDef}) => btnDef?.color && _.get(theme.palette, btnDef.color) || theme.palette.common.white,
		borderRadius: 10,
		borderColor: theme.palette.primary.dark,
		textTransform: 'none',
		padding: theme.spacing(0.5, 1),
		overflow: 'hidden',
		'&:hover': {
			backgroundColor: ({btnDef}) => btnDef?.backgroundColor && _.get(theme.palette, btnDef.backgroundColor)?.dark || theme.palette.primary.dark,
		},
	},
	label: {
		maxHeight: 20,
	},
}), {name: 'TopNavBarButton'});

export interface TopNavBarButtonProps extends ButtonProps {
	btnDef?: TopNavBarButton
	target?: string // ButtonProps has href, but not target
}

export function TopNavBarButtonComponent({btnDef, ...props}: TopNavBarButtonProps) {
	const classes = useStyles({btnDef})
	return <Button {...props} classes={classes}/>
}